export default __webpack_public_path__ + "static/media/profile_empty_icon.05e2a0b3.svg";